<template>
	<div>
		<v-layout class="my-4 verCenteredChild">
			<h5 class="heading ma-0">Transaction History</h5>
			<v-btn icon @click="fetchTransactionHistory('start')" :loading="fetchTransactionHistoryLoading">
				<v-icon>refresh</v-icon>
			</v-btn>
		</v-layout>
		<v-layout>
			<advance-list-view
				:allProps="transactionProps"
				:allData="transactionHistory"
				uniqueKey="transactionId"
				:themeInputColor="themeInputColor"
				:nextOffset="!transactionHistoryOffset ? 'end' : '' "
				@LOAD_MORE_ROWS="fetchTransactionHistory('end')"
				:loadMoreLoading="fetchTransactionHistoryLoading"
				:isTableInteractive="false"
			/>
		</v-layout>
	</div>
</template>

<script>
import { mapState } from "vuex";
import AdvanceListView from "@/components/Advance-list-view";
import { FETCH_TRANSACTION_HISTORY } from "@/store/action-types";
export default {
	name: "TransactionHistory",
	props: ["themeInputColor", "userId"],
	data() {
		return {
			transactionProps: [
				{ text: "User ID", key: "userId", copy_allowed: true },
				{ text: "Transaction time", key: "time" },
				{ text: "Amount", key: "amount" },
				{ text: "Remarks", key: "remarks" },
				{ text: "Status", key: "status", template_type: 2 },
				{ text: "Transaction ID", key: "transactionId" },
				{ text: "Account Info", key: "accInfo" }
			],
			fetchTransactionHistoryLoading: false
		};
	},
	mounted() {
		if (this.userId) {
			this.fetchTransactionHistory("start");
		}
	},
	components: {
		"advance-list-view": AdvanceListView
	},
	computed: {
		...mapState({
			transactionHistory: state =>
				state.retail.grabRetailerTransactionHistory,
			transactionHistoryOffset: state =>
				state.retail.grabRetailerTransactionHistoryOffset
		})
	},
	methods: {
		fetchTransactionHistory(type) {
			if (!this.fetchTransactionHistoryLoading) {
				this.fetchTransactionHistoryLoading = true;
				this.$store
					.dispatch(FETCH_TRANSACTION_HISTORY.dispatch, {
						userId: this.userId,
						limit: 5,
						type
					})
					.catch(() => {})
					.then(() => {
						this.fetchTransactionHistoryLoading = false;
					});
			}
		}
	},
	watch: {
		userId(newVal) {
			if (newVal) {
				this.fetchTransactionHistory();
			}
		}
	}
};
</script>

